import { useState, useEffect } from "react";
import { getSingleJob } from "../../services/auth";
import ReactTimeAgo from "react-time-ago";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
TimeAgo.addDefaultLocale(en);
import moment from "moment";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import jwtDecode from "jwt-decode";

import ReactHtmlParser from "react-html-parser";

function JobView() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [params] = useSearchParams();

  const token = localStorage.getItem("hr_token");

  const [getData, setGetData] = useState({});
  const getFetchData = async (ids, user) => {
    try {
      const datas = {
        jobPostId: ids,
        userId: user,
      };
      const data = await getSingleJob(datas);
      setGetData(data?.data);
    } catch (err) {}
  };
  // useEffect(() => {
  //   const id = localStorage.getItem("getId");
  //   if (id) getFetchData(id);
  // }, []);

  useEffect(() => {
    const token = localStorage.getItem("hr_token");
    if (!token) {
      return;
    }
    try {
      const tokenString = token.split("Bearer ")[1];
      const convertId = jwtDecode(tokenString);
      if (params.get("ViewId") && convertId) {
        getFetchData(params.get("ViewId"), convertId?._id);
      }
    } catch (error) {}
  }, []);

  const {
    gender,
    schoolId,
    companyId,
    title,
    contactDetails,
    salary,
    employmentType,
    description,
    language,
    applierIds,
    createdAt,
    experienceFrom,
    experienceTo,
    approvedIds,
    rejectedIds,
    applyCount,
    approvedCount,
    keySkills,
    workType,
    openings,
    deadlineDate,
    qualification,
    JobCategory,
    timeline,
  } = getData;

  const DateTimeTotal = (
    <ReactTimeAgo
      date={createdAt ? new Date(createdAt) : new Date()}
      locale="en-US"
    />
  );

  const socialContent = [
    {
      id: 1,
      name: "Facebook",
      icon: "fa-facebook-f",
      iconClass: "facebook",
      link: schoolId?.socialNetwork.facebookUrl
        ? schoolId?.socialNetwork.facebookUrl
        : "",
    },
    {
      id: 2,
      name: "Twitter",
      icon: "fa-twitter",
      iconClass: "twitter",
      link: schoolId?.socialNetwork.twitterUrl
        ? schoolId?.socialNetwork.twitterUrl
        : "",
    },
    {
      id: 3,
      name: "Linkedin",
      icon: "fa-likedin",
      iconClass: "linkedin",
      link: schoolId?.socialNetwork.linkedinUrl
        ? schoolId?.socialNetwork.linkedinUrl
        : "",
    },
  ];

  function getRelativeTime(dateString) {
    const backendDate = new Date(dateString);
    const today = new Date();

    // Calculate the difference in days
    const diffTime = today - backendDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "Yesterday";
    return `${diffDays} days ago`;
  }

  const backButton = () => {
    navigate("/manage-jobs");
  };
  return (
    <>
      <div style={{ backgroundColor: "#F6F8FC" }}>
        <span className="header-span"></span>

        <div className="mb-3 ms-5">
          <button
            onClick={backButton}
            className="theme-btn btn-style-one p-2 cursor col-lg-1"
          >
            Back
          </button>
        </div>
        <div className="d-flex justify-content-center mb-5">
          <div className="col-lg-12">
            <div className="row d-flex gap-4 justify-content-center">
              <div
                className="col-lg-11 p-4 shadow-sm rounded"
                style={{ backgroundColor: "white" }}
              >
                <div className="row ">
                  <div className="col-lg-8" style={{ fontSize: "14px" }}>
                    <h5 className="title-home">{title}</h5>
                    <div style={{ color: "grey", fontWeight: "500" }}>
                      {companyId?.profileDetail?.companyName}{" "}
                      {/* <span style={{ fontSize: "12px" }}>
                        ⭐4.1 | 1402 reviews
                      </span> */}
                    </div>
                    <div className="mt-3">
                      {" "}
                      {gender?.charAt(0).toUpperCase()}
                      {gender?.slice(1, 100)} | Exp: {experienceFrom}-
                      {experienceTo} Years | salary: {salary} LPA
                    </div>
                    <div className="mt-1">
                      <span className="icon flaticon-map-locator"></span>{" "}
                      {companyId?.contactDetails?.city}
                    </div>
                  </div>
                  <div className="col-lg-4 d-flex justify-content-end">
                    <div className="d-flex flex-column justify-content-between align-items-end ">
                      {companyId?.profileDetail?.companyLogo ? (
                        <>
                          <img
                            width={"100px"}
                            height={"100px"}
                            src={companyId?.profileDetail?.companyLogo}
                            alt="No Image"
                          />
                        </>
                      ) : (
                        <>
                          {/* <img
                            width={"84px"}
                            height={"80px"}
                            src={"ImageUrl?.Image_Dummy"}
                            alt="No Image"
                          /> */}

                          <i class="fa-solid fa-user"></i>
                        </>
                      )}
                      <div
                        style={{ fontSize: "12px", fontWeight: "600" }}
                      ></div>
                    </div>
                  </div>
                </div>
                <div
                  className="mt-4"
                  style={{ borderBottom: "1px solid #ddd" }}
                ></div>
                <div className="row mt-3">
                  <div
                    className="col-lg-8"
                    style={{
                      fontSize: "12px",
                      color: "grey",
                      fontWeight: "600",
                    }}
                  >
                    <div className="d-flex gap-1">
                      <div
                        className="p-1"
                        style={{ borderRight: "1px solid #ddd" }}
                      >
                        Posted:{" "}
                        <span style={{ color: "black" }}>
                          {getRelativeTime(createdAt)}
                        </span>
                      </div>
                      <div
                        className="p-1"
                        style={{ borderRight: "1px solid #ddd" }}
                      >
                        Opening:{" "}
                        <span style={{ color: "black" }}>{openings}</span>
                      </div>
                      <div className="p-1">
                        Closed Date:{" "}
                        <span style={{ color: "black" }}>
                          {moment(deadlineDate).format("LL")}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="job-description p-4 mt-4  rounded"
                  style={{ fontSize: "14px" }}
                >
                  <div className="bg-light p-2 rounded">
                    <h5 className="fw-bold mb-2 mt-3">Job Description</h5>

                    <h6 className="fw-semibold mt-3 ms-3">About Company</h6>
                    <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                      <li>{companyId?.profileDetail?.description}</li>
                    </ul>
                  </div>

                  <div className="bg-light p-2 mt-4 mb-4">
                    <h5 className="fw-bold mt-4">What We're Looking For...</h5>
                    <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                      <li>{ReactHtmlParser(description)}</li>
                    </ul>
                  </div>

                  <div className="bg-light p-2">
                    <h5 className="fw-bold mt-4 mb-3">Job Details</h5>
                    <p className="ms-4">
                      <strong>Role:</strong> {title}
                    </p>
                    <p className="ms-4">
                      <strong>Job Category: </strong>
                      {JobCategory}
                    </p>
                    <p className="ms-4">
                      <strong>Industry Type:</strong>{" "}
                      {companyId?.typesOfService
                        ? companyId?.typesOfService
                        : "NA"}
                    </p>
                    <p className="ms-4">
                      <strong>Work Mode:</strong> {workType ? workType : "NA"}
                    </p>
                    <p className="ms-4">
                      <strong>Time Line:</strong> {timeline}
                    </p>
                    <p className="ms-4">
                      <strong>Employment Type: </strong>
                      {employmentType}
                    </p>

                    <p className="ms-4 d-flex">
                      <strong>Qualifications: </strong>
                      <span className="ms-2">
                        {qualification && qualification?.join(", ")}
                      </span>
                    </p>

                    <p className="ms-4">
                      <strong>Languages: </strong>
                      <span>{language && language?.join(", ")}</span>
                    </p>
                  </div>

                  <div className="bg-light p-2 mt-4 mb-5">
                    <h5 className="fw-bold mt-4 mb-3">Key Skills</h5>
                    <div className=" d-flex gap-2 mb-4 ms-3 row text-center">
                      {keySkills ? (
                        keySkills.map((item) => {
                          return (
                            <div
                              className="card p-2 cursor"
                              style={{ width: "auto" }}
                            >
                              {item}{" "}
                            </div>
                          );
                        })
                      ) : (
                        <p>loading</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default JobView;
